import { DictionaryItemDto, DictionaryTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export type DictionariesType = Record<DictionaryTypeDto, DictionaryItemDto[]>;

interface Return {
  dictionaries?: DictionariesType;
  isDictionariesError: boolean;
  isFetchingDictionariesTypes: boolean;
}

export const useGetAllDictionaries = (): Return => {
  const { dictionariesApi } = useApiClient();

  const { data, isError, isLoading } = useQuery<DictionariesType, AxiosError>({
    queryFn: async () => {
      const response = await dictionariesApi.getDictionaries();
      const dictionaries = response.data;

      const grouped: Record<DictionaryTypeDto, DictionaryItemDto[]> = {
        [DictionaryTypeDto.Location]: [],
        [DictionaryTypeDto.Status]: [],
        [DictionaryTypeDto.TypeOfStudy]: [],
        [DictionaryTypeDto.UniversityName]: [],
        [DictionaryTypeDto.YearOfStudy]: [],
      };

      dictionaries.forEach(dict => {
        if (dict.identifier?.type && grouped[dict.identifier.type]) {
          grouped[dict.identifier.type].push(dict);
        }
      });

      grouped[DictionaryTypeDto.Location] = grouped[DictionaryTypeDto.Location].sort((a, b) => {
        if (a.identifier?.code === 'POLAND') return -1;
        if (b.identifier?.code === 'POLAND') return 1;
        return (a.label?.value || '').localeCompare(b.label?.value || '');
      });

      return grouped;
    },
    queryKey: [QueryKeyEnum.DICTIONARIES],
  });

  return {
    dictionaries: data,
    isDictionariesError: isError,
    isFetchingDictionariesTypes: isLoading,
  };
};
